export const USER_TYPE = 'PATIENT';
export const LOGIN_PATH = '/login';
